import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { uerRemoveUnusedContractOtherCostsGql } from '../contractOthersQueries';

const requestId = 'uerRemoveUnusedContractOtherCosts';

export const useUerRemoveUnusedContractOtherCosts = (contractId: number, onSuccess?: () => void) => {
    const dispatch = useDispatch();

    const [uerContractObjectsReset] = useResetStoreData({ requestId });

    const [, uerRemoveUnusedContractOtherCostsStatus, , uerRemoveUnusedContractOtherCostsRequest] = useRequest({
        requestId,
        query: uerRemoveUnusedContractOtherCostsGql,
        withEffect: false,
        dependenciesUpdater: onSuccess,
    });

    const uerRemoveUnusedContractOtherCostsMakeRequest = useCallback(() => {
        uerContractObjectsReset(undefined);
        dispatch(uerRemoveUnusedContractOtherCostsRequest({ contractId }));
    }, [contractId, dispatch, uerContractObjectsReset, uerRemoveUnusedContractOtherCostsRequest]);

    useEffect(() => {
        uerContractObjectsReset(undefined);
    }, [uerContractObjectsReset]);

    return {
        uerRemoveUnusedContractOtherCostsStatus,
        uerRemoveUnusedContractOtherCostsMakeRequest,
    };
};
